export default __webpack_public_path__ + "static/media/mail-bounced.c03a6dd5.svg";